
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SignInForm } from "./SignInForm";
import { SignUpForm } from "./SignUpForm";
import { MagicLinkForm } from "./MagicLinkForm";

type AuthMode = "signin" | "signup" | "magic-link";

interface AuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  mode: AuthMode;
  onModeChange: (mode: AuthMode) => void;
  redirectPath?: string;
}

export function AuthDialog({ 
  open, 
  onOpenChange, 
  onSuccess, 
  mode, 
  onModeChange,
  redirectPath 
}: AuthDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {mode === "signup" ? "Create an account" : 
             mode === "magic-link" ? "Magic Link Sign In" : 
             "Sign in"}
          </DialogTitle>
          <DialogDescription>
            {mode === "signup" 
              ? "Sign up to track your career matches and future recommendations."
              : mode === "magic-link"
              ? "Receive a sign in link via email — no password needed."
              : "Sign in to continue your career exploration journey."}
          </DialogDescription>
        </DialogHeader>
        
        {mode === "signin" ? (
          <SignInForm 
            onSuccess={onSuccess}
            onSwitchMode={() => onModeChange("signup")}
            onMagicLinkMode={() => onModeChange("magic-link")}
            redirectPath={redirectPath}
          />
        ) : mode === "magic-link" ? (
          <MagicLinkForm 
            onSwitchMode={() => onModeChange("signin")}
          />
        ) : (
          <SignUpForm 
            onSuccess={onSuccess}
            onSwitchMode={() => onModeChange("signin")}
            redirectPath={redirectPath}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
